import { Money } from '@dreryk/money-common-api';

import { Text, TextSeparator, TextSeparatorType, TextView } from '@dreryk/react-components';
import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { AdvancePaymentRefundAmountCondition } from './AdvancePaymentRefundAmountConditionText';

const EMPTY_PLACEHOLDER = '-';

type AdvancePaymentRefundAmountTextViewProps = Readonly<{
   refundAmount: Money | null | undefined;
   expirationDate: Date | null | undefined;
}>;

export const AdvancePaymentRefundAmountTextView = (props: AdvancePaymentRefundAmountTextViewProps): JSX.Element => {
   return (
      <TextView testId={'refundAmount'} label={translationKeys.advancePaymentRefundAmount}>
         {props.refundAmount ? (
            <TextSeparator separator={TextSeparatorType.SPACE}>
               <Text testId={'amount'}>
                  {priceFormatter(
                     props.refundAmount.asNumber(),
                     getCustomFormattingContext({
                        options: {
                           currency: 'PLN',
                           stripDecimalZeroes: true,
                        },
                     })
                  )}
               </Text>
               <AdvancePaymentRefundAmountCondition refundExpirationDate={props.expirationDate} />
            </TextSeparator>
         ) : (
            EMPTY_PLACEHOLDER
         )}
      </TextView>
   );
};
